import React from "react";
import {  NavLink } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useGetTopInternationalQuery } from "../apis/TopInternational";

const TopInternationalSales = () => {
 
 
  const {
    data: topInternationalData,
     isLoading,
    isFetching
  } =  useGetTopInternationalQuery();

//console.log('topInternationalData',topInternationalData);

  
 
  if (isLoading) return (
          <div className="flex-center py-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
              <CircularProgress />
          </div>
      ); 

  return (
    <section className='vendors-list py-20'>
 
       <div className='container container-lg'>
       <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Top international sales</h5>
                    </div>
                </div>
        <div className='row gy-4'>
          <div>
            
            {/* Products Start */}
            {isFetching && <CircularProgress />}

            <div className='mt-5 row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-3 row-cols-xl-4 row-cols-xxl-6 g-12'>
              {topInternationalData?.map((product) => {
 
                return (
                  <div className='col' key={product.id}>
                    <div className='product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2'>
                      <NavLink
                    to={`/displays-category/${product.subCategories.id}`}
                    className='product-card__thumb flex-center'
                      >
                        <img src={product.url} />
                      </NavLink>

                      <div className='product-card__content p-sm-2 w-100'>
                        <h6 className='title text-lg fw-semibold mt-12 mb-8'>
                          <NavLink
                    to={`/displays-category/${product.subCategories.id}`}
                            className='link text-line-2'
                          >
                            {product.description}
                          </NavLink>
                        </h6>
                        
                      </div>
                      <div className="flex items-center gap-4">
                            <span className="text-main-600 text-md flex">
                                <i className="ph-fill ph-storefront" />
                            </span>
                            <span className="text-gray-500 text-xs">
                                {product.categoryProduct?.name && product.subCategories?.name
                                ? `${product.categoryProduct.name} / ${product.subCategories.name}`
                                : 'Generic Store'}
                            </span>
                            </div>

                    </div>
                  </div>
                );
              })}
            </div>
 
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopInternationalSales;